export const replaceFalse = (value, yesNoMode?: boolean) => {
  if (yesNoMode) return value ? 'Да' : 'Нет';

  return value ? value : '-';
};
